import "./App.css"
import { privateRouter } from "./routes/privateRouter"
import { RouterProvider } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { findAll as findAllAux, getAux } from "./store/features/auxSlice"
import { findAll as findAllConf, getConf } from "./store/features/confSlice"
import { Backdrop, CircularProgress } from "@mui/material"
import { publicRouter } from "./routes/publicRouter"
import { getAuth, resume } from "./store/features/authSlice"
import axios from "axios"

const { REACT_APP_API_ROUTE: API_ROUTE } = process.env

export const App = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [isReady, setIsReady] = useState(false)
  const dispatch = useDispatch()
  const aux = useSelector(getAux)
  const conf = useSelector(getConf)
  const auth = useSelector(getAuth)

  useEffect(() => {
    dispatch(findAllAux())
    dispatch(findAllConf())
    verifyToken()
  }, [])

  useEffect(() => {
    if (
      aux.status === "loading" ||
      conf.status === "loading" ||
      auth.status === "loading"
    ) {
      setIsLoading(true)
    } else {
      setIsLoading(false)
    }
  }, [aux.status, conf.status, auth.status])

  useEffect(() => {
    if (
      aux.status + "|" + conf.status + "|" + auth.status ===
      "succeeded|succeeded|succeeded"
    ) {
      setIsReady(true)
    } else {
      setIsReady(false)
    }
  }, [aux.status, conf.status, auth.status])

  const verifyToken = async () => {
    const me = JSON.parse(localStorage.getItem("cipmovil-me"))

    if (!!me) {
      try {
        const endpoint = `/auth/verify`
        await axios.get(API_ROUTE + endpoint, {
          headers: { Authorization: me.jwtToken },
        })
        console.log("Autorizado")
        dispatch(resume(me))
      } catch (err) {
        console.log(err)
        console.log("La sesión ha caducado")
        localStorage.removeItem("cipmovil-me")
      }
    }
  }

  return (
    <div>
      {isLoading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      {isReady ? (
        <RouterProvider router={privateRouter} />
      ) : (
        <RouterProvider router={publicRouter} />
      )}
    </div>
  )
}
